/**
 * the paths of the redux store.
 */
class ReduxStoreRoutes {
    static userProfile: string = 'user-profile';
    static operatorProfile: string = 'operator-profile';
    static vendorProfile: string = 'vendor-profile';
    static taskMoreInfo: string = 'task-more-info';
    static dialogs = {
        base: 'dialogs',
        whatsNew: 'whats-new',
        quickOrders: 'quick-orders',
        taskMoreInformation: 'task-more-info',
        upsertTask: 'upsert-task',
        upsertNote: 'upsert-note',
        welcomePanelTaskDialog: 'welcome-panel-task-dialog',
        removeConfirmation: 'remove-confirmation',
        confirmation: 'confirmation',
        editBizForm: 'edit-biz-form',
        viewInstallationGuide: 'view-installation-guide',
    };
}

export default ReduxStoreRoutes;
